import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setNewAlertsCount } from 'src/store/modules/alerts'
import {
  setAlertTypes,
  setAlertsByCaseManagers,
  setAlertsByFacilities,
  setAlertsForDashboard,
  setAlertsPriorityCount,
  setPatientAlertList
} from 'src/store/modules/alerts/actionCreators'

import {
  ALERT_GET_EXPORT_LIST,
  CLOSE_RELATED_ALERTS,
  DATE_TIME_FORMAT_FOR_SERVER,
  GET_PATIENT_OPEN_ALERTS,
  POST_ALERTS_BATCH_CLOSE
} from 'src/constants'
import api from 'src/services/@core/API'
import { exportReport } from 'src/utils/Functions'

export const getAlerts = (filters) => () => api.getAlerts(null, filters)

export const getPatientOpenAlerts =
  (config = {}) =>
  async () => {
    const { params = {}, query = {} } = config

    try {
      const response = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATIENT_OPEN_ALERTS,
          params,
          query
        }
      })

      return response
    } catch (err) {
      catchError(err)
    }
  }

export const fetchPatientAlertList = (filters) => async (dispatch) => {
  try {
    const { items: patientAlertList } = await api.getAlerts(null, filters)

    dispatch(setPatientAlertList(patientAlertList))
  } catch (err) {
    catchError(err)
  }
}

export const getAlert = (params, query) => () => api.getAlert(params, query)

export const getAlertHistory = (id, query) => () =>
  api.getAlertHistory({ id }, query)

export const postAlertHistory = (id, payload) => () =>
  api.postAlertHistory({ id }, null, payload)

export const getAlertTypes = () => (dispatch) =>
  api
    .getAlertTypes()
    .then((types) => dispatch(setAlertTypes(types.items)))
    .catch((err) => catchError(err))

export const getNewAlertsCount = () => async (dispatch) => {
  try {
    const alerts = await api.getNewAlertsCount()
    dispatch(setNewAlertsCount(alerts ? alerts.count : 0))
  } catch (err) {
    catchError(err)
  }
}

export const getAlertsPriorityCount = (filters) => async (dispatch) => {
  try {
    const count = await api.getAlertsPriorityCount(null, filters)
    dispatch(setAlertsPriorityCount(count))
  } catch (err) {
    catchError(err)
    dispatch(setAlertsPriorityCount({}))
  }
}

export const postAlertsBatchClose =
  (config = {}) =>
  async () => {
    try {
      const { payload = {}, query = {} } = config

      await httpClient.request({
        method: 'post',
        url: {
          pathname: POST_ALERTS_BATCH_CLOSE,
          query
        },
        payload
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const closeRelatedAlerts = (payload) => async () => {
  try {
    await httpClient.request({
      method: 'post',
      url: {
        pathname: CLOSE_RELATED_ALERTS
      },
      payload
    })

    return true
  } catch (err) {
    catchError(err)

    return false
  }
}

export const exportAlertList =
  (config = {}) =>
  async () => {
    const updConfig = {
      pathname: ALERT_GET_EXPORT_LIST,
      ...config
    }
    const fileNameDefault = `alert_list_${moment().format(
      DATE_TIME_FORMAT_FOR_SERVER
    )}.xls`

    await exportReport(updConfig, fileNameDefault)
  }

export const getDashboardAlerts = (params, payload) => async (dispatch) => {
  try {
    const { items } = await api.getDashboardAlerts(params, payload)

    dispatch(setAlertsForDashboard(items))
  } catch (err) {
    catchError(err)
  }
}

export const getDashboardAlertsByCM = (params, payload) => async (dispatch) => {
  try {
    const data = await api.getDashboardAlertsByCM(params, payload)

    dispatch(setAlertsByCaseManagers(data))
  } catch (err) {
    catchError(err)
  }
}

export const getDashboardAlertsByFacility =
  (params, payload) => async (dispatch) => {
    try {
      const data = await api.getDashboardAlertsByFacility(params, payload)

      dispatch(setAlertsByFacilities(data))
    } catch (err) {
      catchError(err)
    }
  }
